module.exports = __webpack_public_path__ + "static/media/cha_bbobi_M.519879cd.svg";